{
  "id": "thor",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Thor",
    "en": "Thor"
  },
  "icon": "gods/thor",
  "portrait": "gods/thor-portrait",
  "modifiers": [
    {
      "target": "cost",
      "op": "add",
      "value": -10,
      "scope": {
        "ids": ["dwarf"],
        "resources": ["gold"]
      },
      "note": "Dwarves cost 50 gold."
    },
    {
      "target": "gatherRate",
      "op": "pct",
      "value": 0.25,
      "scope": {
        "ids": ["dwarf"],
        "sources": ["hunt", "herd", "berries", "farm", "wood"]
      },
      "note": "Dwarves gather food and wood 25% faster."
    },
    {
      "target": "cost",
      "op": "pct",
      "value": -0.1,
      "scope": {
        "ids": [
          "copper-weapons-thor",
          "copper-armor-thor",
          "copper-shields-thor",
          "bronze-weapons-thor",
          "bronze-armor-thor",
          "bronze-shields-thor",
          "iron-weapons-thor",
          "iron-armor-thor",
          "iron-shields-thor",
          "ballistics-thor",
          "burning-pitch-thor",
          "dwarven-weapons",
          "meteoric-iron-armor",
          "dragonscale-shields",
          "hammer-of-thunder",
          "dwarven-breastplate-thor"
        ]
      },
      "note": "Armory technologies (techtype ArmoryTechnology) cost x0.90 BasePercent, favor included."
    }
  ],
  "startExtras": {
    "units": {
      "gatherer": 0,
      "dwarf": 3
    }
  },
  "powers": ["dwarven-mine"],
  "minors": {
    "classical": ["freyja", "forseti"],
    "heroic": ["skadi", "bragi"],
    "mythic": ["baldr", "tyr"]
  },
  "unlocks": [
    "dwarven-armory",
    "copper-weapons-thor",
    "copper-armor-thor",
    "copper-shields-thor",
    "bronze-weapons-thor",
    "bronze-armor-thor",
    "bronze-shields-thor",
    "iron-weapons-thor",
    "iron-armor-thor",
    "iron-shields-thor",
    "ballistics-thor",
    "burning-pitch-thor",
    "dwarven-weapons",
    "meteoric-iron-armor",
    "dragonscale-shields",
    "hammer-of-thunder",
    "dwarven-breastplate-thor"
  ],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "startExtras replaces the 3 starting Gatherers with 3 Dwarves (major_gods.xml startingunits: 3 VillagerDwarf). ArchaicAgeThor: Dwarven Mine (cooldown 120); Dwarf gold -10 (Absolute); Dwarf hunt/herd/berries/farm/wood x1.25 BasePercent; ArmoryTechnology cost x0.90 BasePercent (food, wood, gold, favor). Not expressed: Dwarven Armory replaces the Armory and researches from the Archaic Age (rate 0.33 Archaic, 1.0 Classical, 1.5 Heroic, 2.0 Mythic); every ArmoryTechnology researched spawns 1 free Dwarf there (ThorDwarfSpawn); 3 extra armory techs (Dwarven Weapons, Meteoric Iron Armor, Dragonscale Shields)."
  }
}
